import { Batch, BatchPayload, Connection, ConnectionDetail, ConnectionSchema, DatasourceEditPayload, DatasourceForm } from "../utils/models/sqlpad";
import { sqlpadInstance } from "./api-client";


export const sqlpadService = {
    // get all connection list
    getConnectionsList: async (): Promise<Connection[]> => {
        try {
            const response = await sqlpadInstance.get<Connection[]>('/connections');
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },

    // get a single connection
    getConnection: async (connId: string): Promise<ConnectionDetail> => {
        try {
            const response = await sqlpadInstance.get<ConnectionDetail>(`/connections/${connId}`);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },

    // createa a new connection
    createConnection: async (payload: DatasourceForm): Promise<Connection> => {
        try {
            const response = await sqlpadInstance.post<Connection>('/connections', payload);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },

    // update the connection
    updateConnection: async (connID: string, payload: DatasourceEditPayload): Promise<Connection> => {
        try {
            const response = await sqlpadInstance.put<Connection>(`/connections/${connID}`, payload);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },

    // test a connection
    testConnection: async (payload: DatasourceForm): Promise<number> => {
        try {
            const response = await sqlpadInstance.post('/test-connection', payload);
            return response.status;
        } catch (error: any) {
            throw error;
        }
    },

    // delete a connection
    deleteConnection: async (connectionId: string): Promise<number> => {
        try {
            const response = await sqlpadInstance.delete(`/connections/${connectionId}`);
            return response.status;
        } catch (error: any) {
            throw error;
        }
    },

    // get selected connection schema
    getConnectionSchema: async (connectionId: string): Promise<ConnectionSchema> => {
        try {
            const response = await sqlpadInstance.get<ConnectionSchema>(`/connections/${connectionId}/schema`);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },

    // create a batch
    createBatches: async (payload: BatchPayload): Promise<Batch> => {
        try {
            const response = await sqlpadInstance.post<Batch>('/batches', payload);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },

    // get batch details for columns list
    getBatchDetails: async (batchId: string): Promise<Batch> => {
        try {
            const response = await sqlpadInstance.get<Batch>(`/batches/${batchId}`);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },

    // get a statement for results for database query
    getStatementForResults: async (statementId: string): Promise<any[][]> => {
        try {
            const response = await sqlpadInstance.get<any[][]>(`/statements/${statementId}/results`);
            return response.data;
        } catch (error: any) {
            throw error;
        }
    },
}